import { runOnFeatureInit } from '@frontend/vanilla/core';

import { MinigamesWidgetRegistration } from './widget-registration.service';

export function provide() {
    return [runOnFeatureInit(MinigamesWidgetRegistration)];
}
